import { faWallet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { formatCurrencyAmount, useCurrency } from '@modules/Orders/shared/hooks/useCurrency';
import type { WalletDetail } from '../../models/Wallet';

const DEFAULT_EMPTY_VALUE = 'N/D';

const formatCurrency = (value: number, currency?: string, emptyValueLabel: string = DEFAULT_EMPTY_VALUE) => {
  if (Number.isNaN(value)) return emptyValueLabel;

  return formatCurrencyAmount(value, currency || 'EUR');
};

interface WalletBalanceProps {
  walletDetail?: WalletDetail | null;
}

export const WalletBalance = ({ walletDetail }: WalletBalanceProps) => {
  const { t } = useTranslation('walletsModule');
  const userCurrency = useCurrency();

  if (!walletDetail) return null;

  const balance = walletDetail.balance_total ?? 0;
  const currency = walletDetail.currency || userCurrency;
  const formattedBalance = formatCurrency(balance, currency);

  return (
    <div className="inline-flex items-center gap-2.5 bg-card-bg border border-card-border rounded-md px-3 py-2">
      <FontAwesomeIcon icon={faWallet} className="w-4 h-4 text-icons" />
      <div className="flex flex-col leading-tight">
        <span className="text-xs text-complementary-text">{t('balance.label')}</span>
        <span className="text-lg font-semibold text-title">{formattedBalance}</span>
      </div>
    </div>
  );
};
